
import { reactive, toRefs } from "vue";
import { FilterCondition } from "@/types/index";

export default {
  name: "Tag",
  props: {
    filterCondition: Array
  },
  emits: ['handleCloseTag'],
  setup(props:any, context:any) {
    const data = reactive({});
    const handleCloseTag = (tag: FilterCondition, index: number) => {
      context.emit('handleCloseTag', tag, index)
    }
    return {
      ...toRefs(data),
      handleCloseTag
    };
  },
};
